/**
 * Feeds `PendingWritesService`: every request that can change data on the
 * server is counted from the moment it is sent until it settles, whether it
 * succeeds, fails or is cancelled. Reads are left alone. Nothing here changes a
 * request, a response or an error.
 */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { PendingWritesService } from '../services/pending-writes.service';

const READ_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

@Injectable()
export class PendingWritesInterceptor implements HttpInterceptor {
  constructor(private pendingWrites: PendingWritesService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (READ_METHODS.has(req.method.toUpperCase())) return next.handle(req);

    return defer(() => {
      this.pendingWrites.begin();
      return next.handle(req).pipe(finalize(() => this.pendingWrites.end()));
    });
  }
}
